import { getEstadoCuentaDevolucionDowload } from "../services/documentosService";
import { getDevolucionesValidasAll, putAceptarDevolucion, putDeclinarSolitudRembolsoFinanzas } from "../services/refoundService";

const dataInicial = {
    listDevolucionesAceptadas: [],
    pagina: 0,
    registros: 10,
    busqueda: "0",
    total: 0,
    exito: 0,
};

const GET_DEVOLUCIONES_ACEPTADAS_ALL = "GET_DEVOLUCIONES_ACEPTADAS_ALL";
const GET_DEVOLUCIONES_ACEPTADAS_PAGINA = "GET_DEVOLUCIONES_ACEPTADAS_PAGINA";
const GET_DEVOLUCIONES_ACEPTADAS_REGISTROS = "GET_DEVOLUCIONES_ACEPTADAS_REGISTROS";
const GET_DEVOLUCIONES_ACEPTADAS_BUSQUEDA = "GET_DEVOLUCIONES_ACEPTADAS_BUSQUEDA";
const CLEAR_DEVOLUCIONES_ACEPTADAS = "CLEAR_DEVOLUCIONES_ACEPTADAS";
const GET_DEVOLUCIONES_ESTADO_CUENTA_DOWLOAD = "GET_DEVOLUCIONES_ESTADO_CUENTA_DOWLOAD"
const PUT_DEVOLUCIONES_ACEPTADAS_APROVAR = "PUT_DEVOLUCIONES_ACEPTADAS_APROVAR"
const PUT_DEVOLUCIONES_ACEPTADAS_DECLINAR = "PUT_DEVOLUCIONES_ACEPTADAS_DECLINAR"

export default function devolucioenesAceptadasReducer(state = dataInicial, action) {
    switch (action.type) {
        case PUT_DEVOLUCIONES_ACEPTADAS_DECLINAR:
            return { ...state, exito: action.payload.exito }
        case PUT_DEVOLUCIONES_ACEPTADAS_APROVAR:
            return { ...state, exito: action.payload.exito }
        case GET_DEVOLUCIONES_ESTADO_CUENTA_DOWLOAD:
            return { ...state, exito: action.payload.exito}
        case GET_DEVOLUCIONES_ACEPTADAS_ALL:
            return { ...state, listDevolucionesAceptadas: action.payload.listDevolucionesAceptadas, total: action.payload.total }
        case GET_DEVOLUCIONES_ACEPTADAS_PAGINA:
            return { ...state, listDevolucionesAceptadas: action.payload.listDevolucionesAceptadas, pagina: action.payload.pagina, total: action.payload.total }
        case GET_DEVOLUCIONES_ACEPTADAS_REGISTROS:
            return { ...state, listDevolucionesAceptadas: action.payload.listDevolucionesAceptadas, registros: action.payload.registros, total: action.payload.total }
        case GET_DEVOLUCIONES_ACEPTADAS_BUSQUEDA:
            return { ...state, listDevolucionesAceptadas: action.payload.listDevolucionesAceptadas, busqueda: action.payload.busqueda, total: action.payload.total, pagina: action.payload.pagina, registros: action.payload.registros }
        case CLEAR_DEVOLUCIONES_ACEPTADAS:
            return { ...state, listDevolucionesAceptadas: action.payload.array, pagina: action.payload.pagina, registros: action.payload.registros, busqueda: action.payload.busqueda }
        default:
            return state;
    }
}

export const obtenerDevolucionesAceptadasAction = () => async (dispatch, getSate) => {
    const { busqueda, pagina, registros } = getSate().devolucionesAceptadas
    return await getDevolucionesValidasAll({ Pagina: pagina + 1, Referencia: busqueda, Registros: registros }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_ACEPTADAS_ALL,
            payload: {
                listDevolucionesAceptadas: Response.Devoluciones,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}

export const obtenerDevolucionesAceptadasPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { busqueda, registros } = getSate().devolucionesAceptadas
    return await getDevolucionesValidasAll({ Pagina: Pagina + 1, Referencia: busqueda, Registros: registros }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_ACEPTADAS_PAGINA,
            payload: {
                listDevolucionesAceptadas: Response.Devoluciones,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerDevolucionesAceptadasRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { busqueda, pagina } = getSate().devolucionesAceptadas
    return await getDevolucionesValidasAll({ Referencia: busqueda, Pagina: pagina + 1, Registros }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_ACEPTADAS_REGISTROS,
            payload: {
                listDevolucionesAceptadas: Response.Devoluciones,
                total: Response.Total,
                registros: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerDevolucionesAceptadasBusquedaAction = ({ Referencia }) => async (dispatch, getSate) => {
    return await getDevolucionesValidasAll({ Referencia: Referencia, Pagina: dataInicial.pagina + 1, Registros: dataInicial.registros }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_ACEPTADAS_BUSQUEDA,
            payload: {
                listDevolucionesAceptadas: Response.Devoluciones,
                total: Response.Total,
                busqueda: Referencia,
                registros: dataInicial.registros,
                pagina: dataInicial.pagina,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerEstadoCuentaDevolucionAction = ({ IdDevolucionSolicitud }) => async (dispatch, getSate) => {
    return await getEstadoCuentaDevolucionDowload({ IdDevolucionSolicitud }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_ESTADO_CUENTA_DOWLOAD,
            payload: {
               exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const aprobarDevolucionAction = ({ IdDevolucionSolicitud, IdMoneda, Monto, TipoCambio }) => async (dispatch) => {
    return await putAceptarDevolucion({ IdDevolucionSolicitud, IdMoneda, Monto, TipoCambio }).then(Response => {
        dispatch({
            type: PUT_DEVOLUCIONES_ACEPTADAS_APROVAR,
            payload: {
               exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const declinarDevolucionAction = ({ IdDevolucionSolicitud }) => async (dispatch) => {
    return await putDeclinarSolitudRembolsoFinanzas({ IdDevolucionSolicitud }).then(Response => {
        dispatch({
            type: PUT_DEVOLUCIONES_ACEPTADAS_DECLINAR,
            payload: {
               exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}


